<!-- label -->
<p class="h4 m-b-4">{{label}}</p>

<!-- price from to -->
<price class="p2"
       [value]="minModel"></price>
&nbsp;-&nbsp;
<price class="p2"
       [value]="maxModel"></price>

<!-- range slider -->
<range-slider class="m-t-6 m-b-8"
              [value]="rangeMin"
              [highValue]="rangeMax"
              [options]="options"
              (userChange)="onUserChange($event)"
              (userChangeEnd)="onUserChangeEnd($event)"></range-slider>
